<template>
  <div class="page-wrapper">
    <menu-dispatcher></menu-dispatcher>

    <div class="wrapper">
      <header-dispatcher></header-dispatcher>
      <div class="screen-container">
        <div class="center-content">
          <div class="content-box">
            <div class="content-head">
              <div class="title">
                <router-link to="/directories">
                  <a class="back" title="Назад"><img src="../image/back.png"></a>
                </router-link>
                Справочники
              </div>
              <div class="cabinet-body"></div>
            </div>
            <div class="content-body directorys-page">
              <div class="cabinet-info">
                <div class="directory-box">
                  <div class="main-content">
                    <div class="head-panel visibility">
                      <div class="title">ГСМ</div>
                    </div>
                    <table cellpadding="0" cellspacing="0">
                      <thead>
                      <tr>
                        <td>Цена, руб.</td>
                        <td>Зар. плата, руб.</td>
                        <td>Минимальная зар. плата, руб.</td>
                        <td>Минимальная стоимость, руб.</td>
                      </tr>
                      </thead>
                      <tbody>
                      <tr title="Изменить" v-for="category in petrolCategories" @value="category"
                          @key="category.id" @click="openPetrolCategory(category.id)" v-if="!category.removed">
                        <td>{{ category.price }}</td>
                        <td>{{ category.salary }}</td>
                        <td>{{ category.minSalary }}</td>
                        <td>{{ category.minPrice }}</td>
                      </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

    </div>
  </div>
</template>
<script>
    import MenuDispatcher from '@/components/MenuDispatcher.vue'
    import HeaderDispatcher from '@/components/HeaderDispatcher.vue'
    import api from '@/api'

    export default {
  name: 'PetrolCategories',
  components: {
    MenuDispatcher,
    HeaderDispatcher
  },

  data () {
    return {
      petrolCategories: []
    }
  },

  mounted () {
    api
      .getPetrolCategories()
      .then(petrolCategories => {
        if (petrolCategories) {
          this.petrolCategories = []
          this.petrolCategories = petrolCategories
        }
      })

    let body = document.getElementsByTagName('body')[0]
    body.classList.add('cabinet-page')
  },

  destroyed () {
    let body = document.getElementsByTagName('body')[0]
    body.classList.remove('cabinet-page')
  },

  methods: {
    openPetrolCategory (id) {
      this.$router.push({ name: 'PetrolCategory', params: { id: id } })
    }
  }
}
</script>
